import React from "react";
import TranscriptPanel from "@/components/TranscriptPanel";

const Demo = () => {
  const demoTranscript = [
    { text: "This is the transcript for minute 1. You can copy this text using the Copy button on the right, or export it individually as a text file using the Export button. Each segment represents one minute of audio recording.", timestamp: "00:00 - 01:00" },
    { text: "This is the transcript for minute 2. The time range label shows the exact duration of this segment. Notice how each segment has its own set of action buttons for easy management.", timestamp: "01:00 - 02:00" },
    { text: "This is the transcript for minute 3. The scrollbar on the right allows you to navigate through all segments easily. As you record more audio, new segments will be added automatically.", timestamp: "02:00 - 03:00" },
    { text: "This is the transcript for minute 4. You can select and copy text directly from any segment, or use the Copy button to copy the entire segment at once to your clipboard.", timestamp: "03:00 - 04:00" },
  ];

  return (
    <div className="min-h-screen bg-deepspace-bg font-dmsans p-6">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold font-outfit text-[#EDEDED] mb-6 text-center">
          Transcript Panel Demo
        </h1>
        <TranscriptPanel 
          transcript={demoTranscript} 
          isRecording={false} 
          isTranscribing={false}
          sessionTitle="Demo Recording Session"
          startTime={new Date()}
          endTime={null}
        />
      </div>
    </div>
  );
};

export default Demo;
